/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {DataAutomationConnection} from './DataAutomationConnection';

/**
 * The InlineResponse20115 model module.
 * @module model/InlineResponse20115
 * @version 1.0.0
 */
export class InlineResponse20115 {
  /**
   * Constructs a new <code>InlineResponse20115</code>.
   * @alias module:model/InlineResponse20115
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>InlineResponse20115</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20115} obj Optional instance to populate.
   * @return {module:model/InlineResponse20115} The populated <code>InlineResponse20115</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20115();
      if (data.hasOwnProperty('data'))
        obj.data = DataAutomationConnection.constructFromObject(data['data']);
    }
    return obj;
  }
}

/**
 * @member {module:model/DataAutomationConnection} data
 */
InlineResponse20115.prototype.data = undefined;

